import React from 'react'
import AdviserProfile from '../AdviserProfile'
import MobileAdviserProfile from '../MobileAdviserProfile'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Spinner from '../../../common/Spinners/Spinner'
import { fetchPublishedProfile } from './adviserProfileContainerActions'
import {Row, Col} from 'react-bootstrap'
import history from '../../../core/history'
import PropTypes from 'prop-types';

class AdviserProfileContainer extends React.Component {
  static propTypes = {
    adviserId: PropTypes.number.isRequired,
    profile: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    fetchProfile: PropTypes.func.isRequired,
    userLocation: PropTypes.string,
    publishedAdviserProfiles: PropTypes.array.isRequired
  }

  constructor (props) {
    super(props)

    this.contactAdviser = this.contactAdviser.bind(this)
    this.rateAdviser = this.rateAdviser.bind(this)
  }

  componentDidMount () {
    let { profile, fetchProfile, adviserId, publishedAdviserProfiles } = this.props
    if (profile !== null && profile.adviserId !== adviserId) {
      fetchProfile(adviserId, publishedAdviserProfiles)
    }
  }

  contactAdviser () {
  const { profile, adviserId } = this.props
  var adviserNameNoSpaces = profile.adviserName.split(' ').join('_')

  const safeProfile = sanitizeProfile(profile)

  history.push(
    `/adviser/${encodeURIComponent(adviserNameNoSpaces)}/${adviserId}/contact`,
    { adviser: safeProfile }
  )
}

  rateAdviser () {
    const { profile, adviserId } = this.props
    var adviserNameNoSpaces = profile.adviserName.split(' ').join('_')

    const safeProfile = sanitizeProfile(profile)

    history.push(
      `/adviser/${encodeURIComponent(adviserNameNoSpaces)}/${adviserId}/rate`,
      { adviser: safeProfile }
    )
  }

  render () {
    if (this.props.loading) {
      return <Spinner />
    }
    return <Row>
      <Col xs={12} className="d-block d-md-none">
        <MobileAdviserProfile
          profile={this.props.profile}
          contactAdviser={this.contactAdviser}
          rateAdviser={this.rateAdviser}
          investorLocation={this.props.userLocation} />
      </Col>
      <Col sm={12} md={12} lg={12} className="d-none d-md-block">
        <AdviserProfile
          profile={this.props.profile}
          contactAdviser={this.contactAdviser}
          rateAdviser={this.rateAdviser}
          investorLocation={this.props.userLocation} />
      </Col>
    </Row>
  }
}

const mapStateToProps = ({ publishedAdviserProfiles, adviserProfileContainer, findAnIfa }) => {
  return {
    publishedAdviserProfiles: publishedAdviserProfiles,
    profile: adviserProfileContainer.profile,
    loading: adviserProfileContainer.loading,
    userLocation: findAnIfa.searchCriteria.userAddress
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchProfile: fetchPublishedProfile
  }, dispatch)
}

function sanitizeProfile(profile) {
  return {
    adviserId: profile.adviserId,
    adviserName: profile.adviserName,
    company: profile.company ?? '',
    rating: profile.rating
      ? { average: profile.rating.average ?? 0, totalReviews: profile.rating.totalReviews ?? 0 }
      : { average: 0, totalReviews: 0 },
    distanceToAdviser: profile.distanceToAdviser ?? 'Unknown'
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AdviserProfileContainer)
